var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.082 15.5827H6.41536C5.14731 15.5827 4.06656 15.1357 3.17311 14.2416C2.27906 13.3482 1.83203 12.2674 1.83203 10.9993C1.83203 9.73129 2.27906 8.65024 3.17311 7.75618C4.06656 6.86274 5.14731 6.41602 6.41536 6.41602H10.082V8.24935H6.41536C5.65148 8.24935 5.00217 8.51671 4.46745 9.05143C3.93273 9.58615 3.66536 10.2355 3.66536 10.9993C3.66536 11.7632 3.93273 12.4125 4.46745 12.9473C5.00217 13.482 5.65148 13.7493 6.41536 13.7493H10.082V15.5827ZM7.33203 11.916V10.0827H14.6654V11.916H7.33203ZM11.9154 15.5827V13.7493H15.582C16.3459 13.7493 16.9952 13.482 17.5299 12.9473C18.0647 12.4125 18.332 11.7632 18.332 10.9993C18.332 10.2355 18.0647 9.58615 17.5299 9.05143C16.9952 8.51671 16.3459 8.24935 15.582 8.24935H11.9154V6.41602H15.582C16.8501 6.41602 17.9311 6.86274 18.8252 7.75618C19.7186 8.65024 20.1654 9.73129 20.1654 10.9993C20.1654 12.2674 19.7186 13.3482 18.8252 14.2416C17.9311 15.1357 16.8501 15.5827 15.582 15.5827H11.9154Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.6a8f94b8a9c734649735dc65b3e32029.svg";
export { ForwardRef as ReactComponent };